import { Directive, ElementRef, HostListener } from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  standalone: true,
  selector: '[appMayusculas]'
})
export class toUpercaseDirective {
  constructor(
    private el: ElementRef,
    private control: NgControl  // Inyectamos NgControl para sincronizar el modelo
  ) {}

  @HostListener('input', ['$event']) onInput(event: any) {
    const startPos = event.target.selectionStart;
    const endPos = event.target.selectionEnd;
    const upperValue = event.target.value.toUpperCase();

    // Actualiza el valor visual en el input
    event.target.value = upperValue;
    event.target.setSelectionRange(startPos, endPos);

    // Actualiza el modelo (FormControl) sin emitir un nuevo evento 'input'
    if (this.control.control) {
      this.control.control.setValue(upperValue, { emitEvent: false });
    }
  }

  // Opcional: Forzar mayúsculas al pegar texto
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text').toUpperCase() || '';
    document.execCommand('insertText', false, pastedText);
  }
}
